import { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import BannerCard from "src/components/BannerCard/BannerCard";
import SkeletonBox from "src/components/SkeletonBox/SkeletonBox";
import { BreakdownCard } from "../../TravelTransactionDetails/components/PaymentDetails";
import ContactUs from "../../ContactUs/ContactUs";

function HotelPaymentCardSkeleton() {
  return (
    <BannerCard className="p-4! flex flex-col gap-4" rootClassName="bg-background-minimal!">
      <SkeletonBox className="h-5 w-36" />
      {[1, 2].map((card) => (
        <div key={card} className="outline-border-subtle flex flex-col gap-2 rounded-md p-3 outline">
          <div className="flex items-center justify-between">
            <SkeletonBox className="h-4 w-28" />
            <SkeletonBox className="h-4 w-20" />
          </div>
          <div className="bg-border-subtle h-px w-full" />
          <div className="flex flex-col gap-2">
            {[1, 2].map((i) => (
              <div key={i} className="flex items-center justify-between gap-2">
                <SkeletonBox className="h-4 w-24" />
                <SkeletonBox className="h-4 w-16" />
              </div>
            ))}
          </div>
        </div>
      ))}
    </BannerCard>
  );
}

const HotelPaymentCard: FC<{
  payment: { pointsRedeemed: string; cashPaid: string; taxes: string; total: string; processedOn: string };
  isFetching?: boolean;
}> = ({
  payment,
  isFetching,
}) => {
  const { t } = useTranslation();
  if (isFetching) return <HotelPaymentCardSkeleton />;
  return (
    <div className="bg-background-default flex flex-col gap-3 rounded-sm p-5 shadow-sm">
      <div className="flex flex-col gap-4">
        <div className="text-lg font-medium">{t("UserHistory.hotel.paymentDetails")}</div>
        <BreakdownCard
          header={{ label: t("UserHistory.hotel.priceSummary"), value: payment.total }}
          rows={[
            { label: t("UserHistory.hotel.taxesAndFees"), value: payment.taxes },
            { label: t("UserHistory.hotel.totalValue"), value: payment.total },
          ]}
        />
        <BreakdownCard
          header={{ label: t("UserHistory.hotel.paymentBreakdown") }}
          rows={[
            { label: t("UserHistory.hotel.pointsRedeemed"), value: payment.pointsRedeemed },
            { label: t("UserHistory.hotel.cashAmountPaid"), value: payment.cashPaid },
          ]}
        />
      </div>
      <div className="border-border-default! h-1! w-full! border-t border-dashed" />
      <ContactUs />
    </div>
  );
};

export default memo(HotelPaymentCard);
